(ns manatee.user.components
  (:require [goog.string :refer [format]]))

(defn full-name
  [{:keys [first-name last-name] :as _user}]
  (format "%s %s" first-name last-name))
